import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClinicSubscriptionsApi } from '../../../apis/ClinicSubscriptionsApi/ClinicSubscriptionsApi';
import { ICreateClinicSubscription } from '../ClinicSubscription';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export const useCreateClinicSubscription = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: ICreateClinicSubscription) => ClinicSubscriptionsApi.createSubscription(data),
        onSuccess: () => {
            // Invalidate clinic seat usage related queries
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicSeatUsage] });
            queryClient.invalidateQueries({ queryKey: [QueryKeys.healthcareFacility] });
            // Also invalidate the all clinic seat usages query
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicSeatUsage, 'all'] });
        },
    });
}; 